/* global yaCounter55098703 */

import vars from '../globals';
import relatedSlider from '../components/related';
import {hit} from './analitycs';

let $scrollArray;

function getScrollArray() {
	$scrollArray = vars.$siteContainer.find('.article');
	$scrollArray.push(vars.$footer);
}

getScrollArray();

function sortArticle() {
	$scrollArray.each((i, e) => {
		$(e).css({
			zIndex: `-=${i}`,
		});
	});
}

function articleScroll() {
	let currentArticle = parseInt(vars.$html.data('article'), 10);
	let activeArticle = false;
	let sumHeight = 0;
	let articleHeights = [];
	let articleTops = [];
	let startScrollPosition = 0;

	let setLink = (id) => {
		vars.$html
			.data('article', id)
			.attr('data-article', id);

		history.pushState({}, '', `/article/${id}${location.search}`);
	};

	let calcSumHeight = () => {
		sumHeight = 0;

		$scrollArray.each((i, e) => {
			let $this = $(e);

			articleTops[i] = sumHeight;
			articleHeights[i] = $this.outerHeight();

			sumHeight += $this.outerHeight();
		});

		vars.$body.css({
			height: sumHeight, // stylelint-disable-line value-keyword-case
		});
	};

	let setStartScrollPosition = () => {
		if (!vars.$window.scrollTop() && currentArticle !== 1) {
			for (let i = 0; i < articleHeights.length; i++) {
				if (i + 1 >= currentArticle) {
					startScrollPosition = Math.floor(startScrollPosition) + 1;

					break;
				}

				startScrollPosition += articleHeights[i];
			}

			vars.$window.scrollTop(startScrollPosition);
		}
	};

	$scrollArray.each((i, e) => {
		let $this = $(e);

		let thisArticle = parseInt($this.data('article'), 10);
		let isEnded = false;
		let isReady = false;

		relatedSlider.initSlider(i);

		vars.$window.on('scroll.article', () => {
			if (vars.$window.scrollTop() <= articleTops[i]) {
				if (!isReady) {
					TweenMax.to($this, 0, {
						y: 0,
						ease: Linear.easeNone,
					});

					isReady = true;
				}
			} else if (vars.$window.scrollTop() >= articleTops[i] + articleHeights[i]) {
				if (!isEnded) {
					TweenMax.to($this, 0, {
						y: -Math.floor(articleTops[i] + articleHeights[i]),
						ease: Linear.easeNone,
					});

					isEnded = true;
				}
			} else {
				TweenMax.to($this, 0, {
					y: Math.floor(articleTops[i] - vars.$window.scrollTop()),
					ease: Linear.easeNone,
				});

				isReady = false;
				isEnded = false;
			}

			// eslint-disable-next-line max-len
			if (vars.$window.scrollTop() >= articleTops[i] && vars.$window.scrollTop() < articleTops[i] + articleHeights[i]) {
				if (thisArticle !== activeArticle) {
					vars.$siteContainer.find('.article').removeClass('is-active');
					$this.addClass('is-active');
					setLink(thisArticle);

					hit(location.pathname);

					activeArticle = thisArticle;
				}
			}
		});
	});

	vars.$window.on('resize.article', () => {
		calcSumHeight();
	});

	calcSumHeight();
	setStartScrollPosition();
}

function articleLeave() {
	vars.$window.off('.article');
}

export {
	sortArticle,
	articleScroll,
	articleLeave,
};
